import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { SessionState, SessionStateModel } from '../session';
import { Store } from '@ngxs/store';
import { buildAwsApi} from '../util.class';
import { NewsCategories } from 'src/app/news/shared/models/categories-data.model';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class NewsCategoriesApiService {
  keyMapAWS: any;

  constructor(
        private http: BaseApiService,
        private _store: Store,
        @Inject(CORE_CONFIGURATION) private config) {
    const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }


  getCategories(username:string): Observable<NewsCategories> {
    const apiAWS = buildAwsApi(this.keyMapAWS,'news_retrieve_news_groups', {username:username});

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? 'categories-mock',
      awsApi: apiAWS !== null,
    });

  }

  sendSelectedTags(body: any): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'news_save_customer_news_categories', {});

    return this.http.post({
      hideError:false,
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? 'tags-mock',
      awsApi: apiAWS !== null,
      body: body
    });
  }


}
